/**
 * Numeric versionCode comparison for the Android update prompt.
 *
 * Play's In-App Updates API often reports UPDATE_NOT_AVAILABLE on internal
 * testing tracks even when a newer AAB is published. We then compare the
 * running versionCode to a published store version (remote JSON / env).
 * Comparison MUST be numeric — string compare ranks "9" above "88".
 */

/** Play applicationId. Keep in sync with `frontend/capacitor.config.ts` `appId`. */
export const ANDROID_PLAY_PACKAGE_ID = 'com.ascendhealth.comms'

/** HTTPS listing used when the native `market://` intent cannot run. */
export const ANDROID_PLAY_STORE_HTTPS_URL =
  `https://play.google.com/store/apps/details?id=${ANDROID_PLAY_PACKAGE_ID}`

/** Play Store app deep link. Prefer this over a Custom Tabs / WebView open. */
export const ANDROID_PLAY_STORE_MARKET_URL = `market://details?id=${ANDROID_PLAY_PACKAGE_ID}`

export function parseAndroidVersionCode(raw: unknown): number | null {
  if (raw == null || raw === '') return null
  const n = typeof raw === 'number' ? raw : Number(String(raw).trim())
  if (!Number.isFinite(n) || n <= 0) return null
  return Math.floor(n)
}

export function isRunningBehindStoreVersion(
  currentVersionCode: unknown,
  storeVersionCode: number,
): boolean {
  const current = parseAndroidVersionCode(currentVersionCode)
  if (current == null) return false
  return current < storeVersionCode
}

export function maxAndroidVersionCode(...values: Array<number | null | undefined>): number | null {
  let max: number | null = null
  for (const value of values) {
    if (value == null) continue
    if (max == null || value > max) max = value
  }
  return max
}
